import { SET_APPLICATIONS, CLEAR_APPLICATIONS, SET_CURRENT_APPLICATION, CLEAR_CURRENT_APPLICATION } from "../actions/applicationActions";

const initialState = {
  applications: [],
  currentApplication: {},
}

function applicationReducer(state = initialState, action) {
  switch (action.type) {
  case SET_APPLICATIONS:
    return {
      ...state,
      applications: action.payload
    }
  case CLEAR_APPLICATIONS:
    return {
      ...state,
      applications: []
    }
  case SET_CURRENT_APPLICATION:
    return {
      ...state,
      currentApplication: action.payload
    }
  case CLEAR_CURRENT_APPLICATION:
    return {
      ...state,
      currentApplication: {}
    }
  default:
    return state;
  }
}

export default applicationReducer;